angular.module('rjmNg.common.api').constant 'USER_PERMISSION',
  ACCESS: Object.freeze
    ADMIN: 'Admin'
    READONLY: 'Read only'
    STANDARD: 'Standard'
